import { useEffect, useMemo, useState } from 'react'

import { t } from 'i18next'

import BadgeIsValid from '~/components/BadgeIsValid'
import Panel from '~/components/Panel'

import { AdditionalAssetsFormContent } from './AdditionalAssetsFormContent'

const dataAdSize: AssetSettings[] = [
  {
    name: 'main_background' as VideoAdditionalAssetsKeys,
    title: 'Backgound (desktop)',
    size: '1400x400',
    label: '1400x400',
    width: 1400,
    height: 400,
    quantity: 1
  },
  {
    name: 'secondary_background' as VideoAdditionalAssetsKeys,
    title: 'Backgound (mobile)',
    size: '960x1600',
    label: '960x1600',
    width: 960,
    height: 1600,
    quantity: 1
  }
]

export const AdditionalAssets = ({
  handleSectionValidity,
  initialData
}: AdditionalAssetsProps) => {
  const [assetsReady, setAssetsReady] = useState<AssetsReadyToSectionValidity>({
    main_background: false,
    secondary_background: false
  })

  const sectionIsValid = useMemo(
    () => Object.values(assetsReady).every(item => item),
    [assetsReady]
  )

  useEffect(() => {
    handleSectionValidity(sectionIsValid)
  }, [handleSectionValidity, sectionIsValid])

  return (
    <Panel
      iconLeft={<BadgeIsValid isValid={sectionIsValid} />}
      {...(!sectionIsValid && { className: 'border-danger' })}
      title={t('rm:campaign.additionalAssets.title')}
      isCollapsible
    >
      {dataAdSize.map((item, index) => {
        // Filtra assets iniciais por nome (main_background, secondary_background)
        const initialAssetsForThisType =
          initialData?.additional_assets?.filter(
            asset => asset.name === item.name
          ) || []

        return (
          <section className="mb-3" key={index}>
            <AdditionalAssetsFormContent
              assetSettings={item}
              handleAssetsReady={setAssetsReady}
              parentIndex={index}
              initialAssets={initialAssetsForThisType}
            />
          </section>
        )
      })}
    </Panel>
  )
}
